import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material-module';
import { RoleEnum, RoleEnumDisplayName } from '../../interfaces/token/role-enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-role-impersonation-dialog',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  template: `
    <h2 mat-dialog-title>Impersonate Roles</h2>
    <mat-dialog-content>
      <p>Select roles to impersonate:</p>
      <mat-selection-list #roleList>
        @for (role of availableRoles; track role.value) {
          <mat-list-option [value]="role.value" (click)="toggleRole(role.value)">
            {{ role.name }}
          </mat-list-option>
        }
      </mat-selection-list>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="selectedRoles.length === 0">
        Impersonate
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 300px;
    }
    mat-selection-list {
      max-height: 400px;
      overflow-y: auto;
    }
  `]
})
export class RoleImpersonationDialogComponent {
  dialogRef = inject(MatDialogRef<RoleImpersonationDialogComponent>);

  selectedRoles: number[] = [];
  availableRoles = [
    { value: RoleEnum.None, name: RoleEnumDisplayName[RoleEnum.None] },
    { value: RoleEnum.Admin, name: RoleEnumDisplayName[RoleEnum.Admin] },
    { value: RoleEnum.Sales, name: RoleEnumDisplayName[RoleEnum.Sales] },
    { value: RoleEnum.ProjectManager, name: RoleEnumDisplayName[RoleEnum.ProjectManager] },
    { value: RoleEnum.Finance, name: RoleEnumDisplayName[RoleEnum.Finance] },
    { value: RoleEnum.External, name: RoleEnumDisplayName[RoleEnum.External] }
  ];

  toggleRole(roleValue: number): void {
    const index = this.selectedRoles.indexOf(roleValue);
    if (index > -1) {
      this.selectedRoles.splice(index, 1);
    } else {
      this.selectedRoles.push(roleValue);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedRoles);
  }
}
